import { render, staticRenderFns } from "./StripeForm.vue?vue&type=template&id=975f8ca4&scoped=true&"
import script from "./StripeForm.vue?vue&type=script&lang=js&"
export * from "./StripeForm.vue?vue&type=script&lang=js&"
import style0 from "./StripeForm.vue?vue&type=style&index=0&id=975f8ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975f8ca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
